import { uiElements, uiEvent } from "@kluntje/core";
import { VICPageableComponent } from "Components/abstract/wec-m-pageable-component/wec-m-pageable-component";
import { WECLazyImage } from "Components/wec-e-lazy-image/wec-e-lazy-image";
import ImageLightboxService from "Services/ImageLightboxService";

export class WECImageGallery extends VICPageableComponent {
  private lightboxLocked = false;
  @uiElements(".wec-m-image-gallery__item")
  galleryItems: Array<HTMLButtonElement>;

  @uiElements(".wec-m-image-gallery__image")
  images: Array<WECLazyImage>;

  get itemsPerPage(): number {
    return 12;
  }

  get items(): Array<HTMLElement> {
    return this.galleryItems;
  }

  @uiEvent("galleryItems", "click")
  handleItemClick(e: MouseEvent) {
    if (this.lightboxLocked === true) return;
    const currentTarget = e.currentTarget as HTMLButtonElement | null;
    if (currentTarget === null) return;
    this.openLightbox(currentTarget);
  }

  async openLightbox(clickedItem: HTMLButtonElement) {
    this.lightboxLocked = true;
    let activeItemId = this.galleryItems.findIndex(curItem => curItem === clickedItem);
    if (activeItemId === -1) {
      activeItemId = 0;
    }
    await ImageLightboxService.openLightbox(this.images, activeItemId);
    this.lightboxLocked = false;
  }
}

customElements.define("wec-m-image-gallery", WECImageGallery);
